'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import PlanoPageMobile from './Designs/Mobile';
import PlanoPageDesktop from './Designs/Desktop';

export type PlanoPageProps = {
  $comboSlug: string;
};

export default function PlanoPage(props: PlanoPageProps) {
  const { breakpoint } = useBreakpoint();
  return breakpoint === 'mobile' ? (
    <PlanoPageMobile {...props} />
  ) : (
    <PlanoPageDesktop {...props} />
  );
}
